<template>
  <v-container>
    <v-card color="#F5F5F5">
      <v-card-text>
        <v-select
          label="Processo Seletivo"
          clearable
          :items="processosSeletivos"
          item-text="descricao"
          item-value="id"
          v-model="filtro.ps"
        ></v-select>
        <v-select
          label="Chamada"
          clearable
          :items="chamadasByPS"
          item-text="titulo"
          item-value="id"
          v-model="filtro.chamada"
          @change="loadCampus"
        ></v-select>
        <v-select
          label="Campus"
          clearable
          :items="listaDeCampi"
          item-text="nomeCampus"
          item-value="id"
          v-model="filtro.campus"
          @change="loadCursosDoCampus"
        ></v-select>
        <v-select
          label="Curso"
          clearable
          :items="listaDeCursos"
          item-text="nomeCurso"
          item-value="id"
          v-model="filtro.curso"
        ></v-select>

        <v-btn class="mt-3" @click="loadCandidatos" color="primary"
          >Buscar</v-btn
        >
        <v-text-field
          v-model="searchCandidato"
          append-icon="mdi-magnify"
          label="Filtrar"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          dense
          :items="candidatos"
          :headers="colunas"
          :search="searchCandidato"
          :loading="isLoadingCandidatos"
          :item-class="corLinhaCandidato"
          multi-sort
        >
          <!--<template v-slot:item="{ item }">
          <pre>{{ item | json }}</pre> 
        </template>-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import * as CampusService from "@/services/campus.service";
import * as CandidatoService from "@/services/candidato.service";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    listagemPublica: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listaDeCampi: [],
      listaDeCursos: [],
      isLoadingCandidatos: false,
      searchCandidato: "",
      filtro: {
        campus: "",
        curso: "",
        chamada: "",
        ps: "",
        somentePendentes: false,
        somenteNaoRegistrados: false,
      },
    };
  },
  mounted() {
    this.loadProcessosSeletivos();
    this.loadChamadas();
  },
  methods: {
    /*formatarCPF(cpf) {
      if (!cpf) return '';
      return cpf
        .toString()
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    },*/

    loadProcessosSeletivos() {
      this.isLoadingPS = true;
      if (this.listagemPublica) {
        this.$store
          .dispatch("processosSeletivos/loadPublico")
          .catch(() =>
            this.$msg.error("Erro ao carregar a lista de Processos Seletivos!")
          )
          .finally(() => (this.isLoadingPS = false));
      } else {
        this.$store
          .dispatch("processosSeletivos/load")
          .catch(() =>
            this.$msg.error("Erro ao carregar a lista de Processos Seletivos!")
          )
          .finally(() => (this.isLoadingPS = false));
      }
    },

    loadChamadas() {
      this.isLoadingChamadas = true;
      this.$store
        .dispatch("chamadas/load")
        .catch(() => this.$msg.error("Erro ao carregar as chamadas!"))
        .finally(() => (this.isLoadingChamadas = false));
    },

    loadCampus() {
      this.listaDeCursos = [];
      this.listaDeCampi = [];
      this.filtro.campus = null;
      this.filtro.curso = null;
      if (this.filtro.chamada) {
        this.$nprogress.start();
        CampusService.getAllByChamada(this.filtro.chamada)
          .then((res) => (this.listaDeCampi = res.data))
          .finally(() => this.$nprogress.done());
      }
    },

    loadCursosDoCampus() {
      if (this.filtro.campus !== null) {
        this.isLoadingCursos = true;
        CampusService.getAllCursosByChamadaCampus(
          this.filtro.chamada,
          this.filtro.campus
        )
          .then((res) => (this.listaDeCursos = res.data))
          .finally(() => (this.isLoadingCursos = false));
      } else {
        this.listaDeCursos = [];
        this.filtro.curso = null;
      }
    },
    
    loadCandidatos() {
      this.isLoadingCandidatos = true;

      CandidatoService.getAllPwd(this.filtro)
        .then((res) =>
          this.$store.commit("candidatos/LOAD_CANDIDATOS", res.data)
        )
        .finally(() => (this.isLoadingCandidatos = false));
    },

    corLinhaCandidato(item) {
      const index = this.candidatos.indexOf(item);
      return index % 2 === 0 ? "BRANCO" : "CINZA";      
    },   
  },
  computed: {
    ...mapGetters({
      chamadas: "chamadas/chamadasByPS",
      processosSeletivos: "processosSeletivos/list",
      candidatos: "candidatos/list",
    }),
    chamadasByPS() {
      return this.chamadas(this.filtro.ps);
    },
    colunas() {
      let colunas = [
        {
          text: "Nome",
          align: "start",
          sortable: true,
          value: "nome",
          width: "",
        },
        {
          text: "CPF",
          align: "start",
          sortable: true,
          value: "cpf",
          width: "",
        },
        {
          text: "Curso",
          align: "start",
          sortable: true,
          value: "curso",
          width: "",
        },
        {
          text: "Campus",
          align: "start",
          sortable: true,
          value: "campus",
          width: "",
        },

        {
          text: "Modalidade",
          align: "start",
          sortable: true,
          value: "modalidade",
          width: "",
        },
        {
          text: "Login",
          align: "center",
          sortable: true,
          value: "login",
          width: "",
        },
        {
          text: "Senha",
          align: "center",
          sortable: true,
          value: "senha",
          width: "",
        },
        {
          text: "E-mail",
          align: "center",
          sortable: true,
          value: "email",
          width: "",
        },
      ];

      return colunas;
    },
  },
};
</script>
